/**
 * Customization for 'jh-spacer' div (ex. seen on Homepage)
 */

jQuery(document).ready(
    function ($) {
        // Check
        if ($(".homepage-light")[0] || $(".homepage-dark")[0]) {
            $(this).find('.jh-spacer').first().css({ "border-top": "none" });
        }
    }
);
